import React, { Component } from "react";
import { Form } from "react-bootstrap";
import { LOGIN_STATUS as loginStat, EXCLUDE_SELECT_CLIENT_FOR_ROLE_ID } from "../../../utils/constant.utils";
import { valueExist } from '../../../utils/helpers.utils';
import Icons from "../../icon";
export class RightSelection extends Component {
    constructor(props) {
        super();
        this.state = {
            internalSelected: false,
            externalSelected: false,
            isShowClientSelection: !valueExist(EXCLUDE_SELECT_CLIENT_FOR_ROLE_ID, parseInt(sessionStorage.getItem('UserRoleID')))
        }
        this.pageRedirectExternal = this.pageRedirectExternal.bind(this);
        this.pageRedirectInternal = this.pageRedirectInternal.bind(this);
    }
   
    async componentWillReceiveProps(nextProps) {
        const { login, isClientUser, loginSelection, redirectToPage, externalRedirectionEnabled, clientSelectionEnabled } = this.props;
        if(nextProps.isClientUser !== isClientUser){
          if(nextProps.isClientUser){
            await this.redirectToInternalExternal(loginStat.external);
          }
        }
        if (externalRedirectionEnabled && nextProps.clientSelectionEnabled !== clientSelectionEnabled) {
            if (nextProps.clientSelectionEnabled) {
                await this.redirectToInternalExternal(loginStat.external);
            }
        }
    }

    componentDidMount() {
        this._isMounted = true;
    }
    
    componentWillUnmount() {
        this._isMounted = false;
    }

    pageRedirectExternal = async (e) => {
        e.preventDefault();
        const { clientScopes, clientSelectionEnabled, isLoggedIn, isClientUser, hasUserScope } = this.props;
        
        if (clientSelectionEnabled && !isLoggedIn){
            await this.redirectToInternalExternal(loginStat.external);
        } else if(hasUserScope && isClientUser && clientScopes.length === 0){
            await this.redirectToInternalExternal(loginStat.external);
        } else if(!clientSelectionEnabled && !this.state.isShowClientSelection){
            await this.redirectToInternalExternal(loginStat.external);
        }        
        if (this._isMounted) {
            this.setState({ internalSelected: false, externalSelected: true });
        }
    }

    pageRedirectInternal = async (e) => {
        e.preventDefault();
        const { clientSelectionEnabled, isLoggedIn, isSsoEnabled } = this.props;
        if (clientSelectionEnabled && !isLoggedIn) {
            await this.redirectToInternalExternal(loginStat.internal);
        }
        //To be implementd for Internal redirection
        var newURL = process.env.REACT_APP_INTERNAL_REDIRECTION_URL;
        if (!isSsoEnabled) {
            let uname = window.localStorage.getItem("atemusername");
            let pass = window.localStorage.getItem("atempassword");

            newURL = newURL +'/'+uname+'/'+pass+'/';
        }
        window.location.replace(newURL);
        this.setState({ internalSelected: true, externalSelected: false });
    }

    displayOptions = data => {
        if (data !== undefined && data !== null && data.length > 0) {
            return data.map(x => {
                return (
                    <option value={x.Value} key={x.Key} id={x.Key}>
                        {x.Value}
                    </option>
                );
            });
        }
    };

    renderEnableExternalRedirection = () => {
        const { onSelectClientScope, clientScopes, clientScopeSelected } = this.props;
        return (
                this.state.isShowClientSelection &&
                <div>
                    <Form.Select onChange={onSelectClientScope}>
                        <option hidden>{clientScopeSelected ? clientScopeSelected : 'Select a client'}</option>
                        {this.displayOptions(clientScopes)}
                    </Form.Select>
                </div>
        )
    }
    renderClientSelection = () => {
        const { internalSelected, externalSelected } = this.state;
        const { onSelectClientScope, clientScopes, isClientUser, clientScopeSelected } = this.props;
        return (
            <>
                {
                    this.state.isShowClientSelection &&
                    <Form.Select onChange={onSelectClientScope}>
                    <option hidden>{clientScopeSelected ? clientScopeSelected : 'Select a client'}</option>
                        {this.displayOptions(clientScopes)}
                    </Form.Select>
                }
                <div className="selection-type-container">
                   <div className={internalSelected ? "selection-internal-container selection-internal-container-selected" : "selection-internal-container"} onClick={this.pageRedirectInternal}>
                       <div className="button-group">
                           <Icons
                               customClassName="icon-circle-username"
                               name="blue-circle-user"
                               size="31px"
                           />
                       </div>
                       Internal
                   </div>
                   <div className="vertical-line"></div>
                   <div className={externalSelected ? "selection-internal-container selection-internal-container-selected" : "selection-internal-container"} onClick={this.pageRedirectExternal}>
                       <div className="button-group">
                           <Icons
                               customClassName="icon-circle-username"
                               name="blue-circle-user"
                               size="31px"
                           />
                       </div>
                       External
                   </div>
                </div>  
            </>
        )
    }

    redirectToInternalExternal = async (redirectTo) => {
        const { login, loginSelection, redirectToPage, setLanguage } = this.props;
        loginSelection(redirectTo);
        await login();
        redirectToPage();
        setLanguage();
    }

    render(){
        const { externalRedirectionEnabled} = this.props;
        return(
            <>                
                {this.state.isShowClientSelection && 
                    <h1 className="right-section-header">
                        Client Selection
                    </h1>
                }
                {
                    externalRedirectionEnabled ? this.renderEnableExternalRedirection() : this.renderClientSelection()
                }
                
                <div className="right-section-group-text">
                    <span>Need help?</span>
                    <a href="/">Click here</a>
                </div>   
            </>
        )
    }
}